import { formatE164PhoneNumber } from '../phone';
import { ENGLISH_ONLY_REGEX } from './countryValidation';

export const INVALID_PHONE_MESSAGE = 'Please enter a valid phone number';

type EnglishOnlyIssueValues = Record<string, string | undefined>;

export type EnglishOnlyField = {
  key: string;
  label: string;
};

export const createPhoneNumberIssues = (phoneNumber: string, countryCode: string) => {
  if (formatE164PhoneNumber({ phoneNumber, countryCode })) {
    return [];
  }

  return [
    {
      code: 'custom' as const,
      message: INVALID_PHONE_MESSAGE,
      path: ['phone'],
      input: phoneNumber,
    },
  ];
};

export const createEnglishOnlyFieldIssues = (values: EnglishOnlyIssueValues, fields: readonly EnglishOnlyField[]) => {
  return fields.flatMap(({ key, label }) => {
    const fieldValue = values[key];
    if (!fieldValue || ENGLISH_ONLY_REGEX.test(fieldValue)) {
      return [];
    }

    return [
      {
        code: 'custom' as const,
        message: `${label} must contain only English characters`,
        path: [key],
        input: fieldValue,
      },
    ];
  });
};
